import { connect } from 'react-redux'
import at from 'lodash/at'
import get from 'lodash/get'

import TechnicianServiceSummaries from '../../components/service-summaries/technician-service-summaries'

import { fetchTechnicianServiceSummariesForWorkOrder } from '../../actions/technician-service-summaries'

function mapStateToProps (state, ownProps) {
  const workOrder = state.workOrders[ownProps.workOrderId]
  const technicianServiceSummaries = get(state.technicianServiceSummaries, workOrder.id, {})
  const technicians = at(state.users, Object.keys(technicianServiceSummaries) || [])

  return {
    workOrder,
    technicians,
    technicianServiceSummaries
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(fetchTechnicianServiceSummariesForWorkOrder(ownProps.workOrderId))
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TechnicianServiceSummaries)



// WEBPACK FOOTER //
// ./src/containers/service-summaries/technician-service-summaries-container.js